<template>
    <div class="v-spinner spinner-centrado" v-show="loading" v-if="propLoading">
        <div class="v-sync v-sync1" v-bind:style="[spinnerStyle,spinnerDelay1]">
        </div><div class="v-sync v-sync2" v-bind:style="[spinnerStyle,spinnerDelay2]">
        </div><div class="v-sync v-sync3" v-bind:style="[spinnerStyle,spinnerDelay3]">
        </div>
      </div>
      <div id="inspire" class="fuente" v-else>
        <v-toolbar class="nav" dense="">
            <v-spacer></v-spacer>
            <v-btn color="#111c3d" style="color:white;" small depressed @click="logout">
              <span>Cerrar Sesión</span>
              <v-icon>mdi-power-standby</v-icon>
            </v-btn>
          </v-toolbar>
        <v-container fluid fill-height>
          <v-layout> 
            <v-flex xs12 sm2 md2>
              <v-navigation-drawer class="drawer" v-model="drawer" 
                absolute
                permanent
                fixed 
                dense>
                <v-img :src="require('../../../assets/PANTALLA-03.png')" contain>
              <div style="display: flex; justify-content: center; align-items: center; height: 250px; background-color: #294697;">
                <v-img
                  class="ma-0 pa-0"
                  :src="require('../../../assets/nova/NOMBREBLANCO.png')"
                  max-height="100"
                  contain
                ></v-img>
              </div>
              </v-img>
                  <v-list dense>
                    
                  <div class="name">{{nombre}}</div>
    
                    <v-list-item-group color="#3945d0">
                      <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                        :to="item.link"
                      >
                        <v-list-item-icon>
                          <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
    
                        <v-list-item-content>
                          <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
    
                      <v-list-item
                      @click="logout">
    
                        <v-list-item-icon>
                          <v-icon>mdi-power-standby</v-icon>
                        </v-list-item-icon>
    
                        <v-list-item-content>
                          <v-list-item-title>CERRAR SESIÓN</v-list-item-title>
                        </v-list-item-content>
    
                      </v-list-item>
    
                    </v-list-item-group>
                  </v-list>
              </v-navigation-drawer>
            </v-flex>
            <v-flex xs12 sm10 md10>
              <v-content>
                <v-container>
                  <router-view  to="children"/>
                </v-container>
              </v-content>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <script>
      export default {
        props: {
          loading: {
            type: Boolean,
            default: true
          },
          color: { 
            type: String,
            default: '#1b4695'
          },
          size: {
            type: String,
            default: '30px'
          },
          margin: {
            type: String,
            default: '2px'
          },
          radius: {
            type: String,
            default: '100%'
          }
        },
        data () {
          return {
            usuario:[],
            propLoading: this.loading,
            nombre: "",
            id: "",
            drawer: true,
            items: [
              { text: "HISTORIAL", icon: "mdi-file-document", link: "/Gestion-entradas-salidas/Admin/Historial"},
              { text: "PERMISOS", icon: "mdi-shield-account", link: "/Gestion-entradas-salidas/Admin/Permisos"},
            ],
            spinnerStyle: {
              backgroundColor: this.color,
              height: this.size,
              width: this.size,
              margin: this.margin,
              borderRadius: this.radius,
              display: 'inline-block',
              animationName: 'v-syncStretchDelay',
              animationDuration: '0.6s',
              animationIterationCount: 'infinite',
              animationTimingFunction: 'ease-in-out',
              animationFillMode: 'both'
            },
            spinnerDelay1: {
              animationDelay: '0.07s'
            },
            spinnerDelay2: {
              animationDelay: '0.14s'
            },
            spinnerDelay3: {
              animationDelay: '0.21s'
            }
          }
        },
        mounted(){
          setTimeout(() => {
            this.propLoading= false
          }, 1000.)
        },
        methods: {
          // metodo par cerrar sesión y remover los datos del localStorage
          logout() {
            localStorage.clear()
            this.$router.push("/");
          },
        },
      }
    </script>